import { render, staticRenderFns } from "./BookingContact.vue?vue&type=template&id=611153d4&"
import script from "./BookingContact.vue?vue&type=script&lang=js&"
export * from "./BookingContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports